import { en } from './en'
import { fr } from './fr'

export const causeAwarenessDates = {
  en,
  fr
}